<template>
    <table>
        <thead>
            <tr>
                <th>Status</th>
                <th class="title">Claim</th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="claim in claims"
                :key="claim.id"
                @click="$emit('claimSelected', claim)"
            >
                <td :class="'status ' + getStatusColorClass(claim.status)">
                    <div class="status-icon">
                        <Status :status="claim.status"></Status>
                    </div>
                    <div class="status-label">
                        <div>{{getStatusTitle(claim.status)}}</div>
                    </div>
                </td>
                <td class="title">
                    {{claim.title}}
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    import { getStatusColorClass, getStatusTitle } from '../utility/StatusGenerator';
    import Status from './StatusIcon.vue';

    export default {
        props: {
            claims: Array
        },
        methods: {
            getStatusColorClass: getStatusColorClass,
            getStatusTitle: getStatusTitle
        },
        data() {
            return {};
        },
        components: {
            Status
        }
    }
</script>

<style scoped lang="scss">
    table {
        margin: 0 auto;
        border: none;
        border-collapse: collapse;
    }

    tbody > tr:hover {
        cursor: pointer;
        background-color: $light-gray;
    }

    td, th {
        text-align: left;
        padding: 0;
    }

    .status {
        width: $space-128;

        .status-icon {
            vertical-align: middle;
            display: inline-block;
            width: $space-32;
            height: $space-32;
        }
    
        .status-label {
            vertical-align: middle;
            display: inline-block;
        }
    }
</style>